interface BrandLogoProps {
  width?: number;
  className?: string;
}

/** Keep the wordmark as text so its exact brand capitalization stays consistent. */
export default function BrandLogo({ width = 152, className = "" }: BrandLogoProps) {
  return (
    <span
      role="img"
      aria-label="ZeAstro"
      data-no-translate
      className={`inline-flex shrink-0 items-center justify-center gap-[0.12em] align-middle text-foreground ${className}`}
      style={{ width, maxWidth: "100%", fontSize: width * 0.195 }}
    >
      <img
        src={`${import.meta.env.BASE_URL}brand/mark-dark-128.png`}
        alt=""
        aria-hidden="true"
        className="h-auto w-[28%] shrink-0"
      />
      <span
        aria-hidden="true"
        className="shrink-0 whitespace-nowrap font-extrabold leading-none tracking-[-0.055em]"
      >
        ZeAstro
      </span>
    </span>
  );
}
